import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import T from 'aegisv2/Text';
import { secondaryMain, primaryMain } from 'crehana-ui/styles/colors';
import { useTranslation } from 'react-i18next';
import { CATALOG_TRANSLATION_KEY } from 'Jsx/Utils/transformKeys';

import Flex from 'Shared/ui/Flex';
import LazyImage from 'Shared/Image';
import Button from 'Catalog/ui/Button';

const StyledLazyImage = styled(LazyImage)`
  height: 200px;
  display: flex;
  ${props => `
    @media (min-width: ${props.theme.media.laptop}) {
      height: 304px;
    }
  `}
  & > div {
    &:first-of-type {
      background-position: center;
    }
  }
`;

const Wrapper = styled(Flex)`
  width: 100%;
  height: 100%;
  color: white;
  margin: 0 auto;
  border-radius: 10px;
  flex-direction: column;
  justify-content: center;

  align-items: flex-start;
  position: absolute;

  @media (min-width: 768px) {
    margin-left: 32px;
    margin-right: 32px;
    width: calc(100% - 64px);
  }

  @media (min-width: 1280px) {
    margin-left: 64px;
    margin-right: 64px;
    width: calc(100% - 128px);
  }
`;

const StyledTitle = styled(Flex)`
  max-width: 630px;
  max-height: 146px;
  overflow: hidden;
  text-align: left;
`;

const Title = styled(T)`
  /* color: inherit !important; */
  font-family: Gilroy, Arial, sans-serif !important;
  font-size: 18px;
  line-height: 27px;
  white-space: normal;
  max-width: 536px;
  @media (min-width: 1024px) {
    font-size: 28.43px !important;
    line-height: 40px !important;
    margin-bottom: 8px !important;
  }
  @media (min-width: 1440px) {
    max-width: 630px;
  }
`;

const Subtitle = styled(T)`
  margin-bottom: 12px;
  /* color: inherit !important; */
`;

const StyledButton = styled(Button)`
  /* border-color: transparent; */
  color: ${props => {
    if (props.whiteButton) {
      return primaryMain;
    }

    return '#fff';
  }};
  box-shadow: none !important;
  background-color: ${props => {
    if (props.whiteButton) {
      return '#fff';
    }
    if (props.topBannerButtonColor) {
      return props.topBannerButtonColor;
    }

    return primaryMain;
  }};
  font-size: 14px;
  border-radius: 0px !important;
  padding: 10px 36px;
  font-size: 16px;
  visibility: visible;
  cursor: pointer;
  border: transparent;
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;
  font-family: Gilroy, Arial, sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
  letter-spacing: 0.4px;

  &:hover {
    background-color: ${secondaryMain};
    border-color: #fff;
    color: #fff;
  }
`;

const Slide = ({
  img,
  title,
  subtitle,
  link,
  titleColor,
  white_button: whiteButton,
  top_banner_button_color: topBannerButtonColor,
}) => {
  const textColor = titleColor || '#fff';
  const { t } = useTranslation(CATALOG_TRANSLATION_KEY);

  return (
    <a href={link} style={{ display: 'block' }}>
      <StyledLazyImage
        bgColor="#cecece"
        lazyUrl={img}
        params={{
          w: 1560,
          h: 304,
        }}
      >
        <Wrapper>
          <StyledTitle a="flex-end">
            <Title l bold color={textColor || 'inherit'}>
              {title}
            </Title>
          </StyledTitle>
          <Subtitle color={textColor || 'inherit'}>{subtitle}</Subtitle>
          {link && (
            <StyledButton
              invert
              p="5px 14px"
              whiteButton={whiteButton}
              topBannerButtonColor={topBannerButtonColor}
            >
              {t('BANNER_BUTTON')}
            </StyledButton>
          )}
        </Wrapper>
      </StyledLazyImage>
    </a>
  );
};

Slide.defaultProps = {
  titleColor: 'white',
  subtitleColor: 'white',
};

Slide.propTypes = {
  img: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  titleColor: PropTypes.string,
  subtitleColor: PropTypes.string,
  white_button: PropTypes.bool.isRequired,
  top_banner_button_color: PropTypes.string.isRequired,
};

export default Slide;
